import { useMemo } from 'react'

export const useConvertToNumericId = (rid: string) => {
  return useMemo(() => {
    if (!rid) {
      return null
    }

    const result = Number(rid)

    return Number.isNaN(result) ? null : result
  }, [rid])
}
